// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3Nmoo","subheader":"ReorderModal_subheader__3yqkA","listWrap":"ReorderModal_listWrap__1ZH4Z"};